/**
 * S7.6-A — HeapBadge
 *
 * Exibe heap livre em KB com cor por threshold:
 *   ≥80 KB         neutro (cinza claro mono)
 *   50-80 KB       amarelo (heapAlert.warn)
 *   <50 KB         vermelho (heapAlert.crit) + ícone ⚠
 *   null/unknown   "—" muted
 *
 * Texto visível: "183.2 KB" via formatBytesKB.
 * Tooltip: nível textual i18n ("Heap baixo (50–80 KB)").
 */
import { formatBytesKB, heapAlertLevel } from "../lib/format.js";
import { t } from "../i18n/index.js";

export default function HeapBadge({ bytes }) {
  const level = heapAlertLevel(bytes);
  if (level === "unknown") {
    return <span className="text-noc-muted font-mono">—</span>;
  }
  const tone = level === "crit"
    ? "text-noc-err"
    : level === "warn"
      ? "text-noc-warn"
      : "text-noc-muted";
  const icon = level === "crit" ? "⚠ " : "";
  const tooltip = t(`heapAlert.${level}`);
  return (
    <span className={`${tone} font-mono`} title={tooltip}>
      {icon}{formatBytesKB(bytes)}
    </span>
  );
}
